export default __webpack_public_path__ + "static/media/Ads.4bb8af61.png";